<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" @click.self="$emit('close')">
    <div class="w-full max-w-sm bg-surface dark:bg-surface-dark rounded-xl shadow-xl">
      <div class="flex items-center justify-between px-6 py-4 border-b border-stroke-subtle dark:border-stroke-dark">
        <h2 class="text-base font-semibold text-fg-base dark:text-fg-base-dark">Change Password</h2>
        <button @click="$emit('close')" class="text-fg-faint hover:text-fg-secondary dark:hover:text-fg-secondary-dark">
          <XMarkIcon class="h-5 w-5" />
        </button>
      </div>

      <form @submit.prevent="submit" class="px-6 py-4 space-y-4">
        <div>
          <label class="block text-sm font-medium text-fg-secondary dark:text-fg-secondary-dark mb-1">Current password</label>
          <input
            v-model="currentPassword"
            type="password"
            autocomplete="current-password"
            required
            class="w-full px-3 py-2 rounded-lg border border-stroke-strong dark:border-stroke-strong-dark bg-surface dark:bg-surface-muted-dark text-fg-base dark:text-fg-base-dark text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-fg-secondary dark:text-fg-secondary-dark mb-1">New password</label>
          <input
            v-model="newPassword"
            type="password"
            autocomplete="new-password"
            required
            minlength="8"
            class="w-full px-3 py-2 rounded-lg border border-stroke-strong dark:border-stroke-strong-dark bg-surface dark:bg-surface-muted-dark text-fg-base dark:text-fg-base-dark text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-fg-secondary dark:text-fg-secondary-dark mb-1">Confirm new password</label>
          <input
            v-model="confirmPassword"
            type="password"
            autocomplete="new-password"
            required
            class="w-full px-3 py-2 rounded-lg border border-stroke-strong dark:border-stroke-strong-dark bg-surface dark:bg-surface-muted-dark text-fg-base dark:text-fg-base-dark text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <p v-if="error" class="text-sm text-red-600 dark:text-red-400">{{ error }}</p>
        <p v-if="success" class="text-sm text-green-600 dark:text-green-400">Password changed successfully.</p>

        <div class="flex justify-end gap-3 pt-1">
          <button
            type="button"
            @click="$emit('close')"
            class="px-4 py-2 text-sm font-medium text-fg-secondary dark:text-fg-secondary-dark hover:bg-surface-muted dark:hover:bg-surface-muted-dark rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            type="submit"
            :disabled="loading"
            class="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 rounded-lg transition-colors"
          >
            {{ loading ? 'Saving…' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

const emit = defineEmits(['close'])

const currentPassword = ref('')
const newPassword = ref('')
const confirmPassword = ref('')
const loading = ref(false)
const error = ref('')
const success = ref(false)

const submit = async () => {
  error.value = ''

  if (newPassword.value.length < 8) {
    error.value = 'New password must be at least 8 characters.'
    return
  }
  if (newPassword.value !== confirmPassword.value) {
    error.value = 'New passwords do not match.'
    return
  }

  loading.value = true
  try {
    const res = await fetch('/api/auth/change-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        current_password: currentPassword.value,
        new_password: newPassword.value,
      }),
    })

    if (!res.ok) {
      const data = await res.json().catch(() => ({}))
      error.value = data.detail || 'Something went wrong.'
      return
    }

    success.value = true
    setTimeout(() => emit('close'), 1500)
  } finally {
    loading.value = false
  }
}
</script>
